import { Heading } from '../../common/form/form-parts';
import ArrowLefticon from '@tradera/blueprint/theme/icons/arrow-left.svg?jsx';
import { Button } from 'tradera/components/atoms/button/button';
import { FormFooterLogo } from 'tradera/apps/registration/components/common/form/form-footer-logo';

export const SwedishPrivateProviderEmailRequired = (props) => {
    const { helpUrl, isNativeAppContext, providerName } = props;
    return (
        <>
            <div />
            <div className={'mt-7'}>
                <Heading>Vi behöver din epost</Heading>
                <div className={'mb-3'}>
                    Som en del av en smidig och trygg tjänst är det viktigt att
                    vi har en e-postadress som är verifierad av {providerName}.
                </div>
                <div className={'mb-3'}>
                    <em>
                        Om du vill slippa detta kan du istället{' '}
                        <a className="link" href="/register">
                            registrera dig utan {providerName}
                        </a>
                        .
                    </em>
                </div>
                <Button theme="primary" fluid className="my-3" href="/register">
                    <ArrowLefticon className="icon icon-before" />
                    Tillbaka
                </Button>
                <div className={'text-center mb-3'}>
                    Har du problem? <a href={helpUrl}>Kontakta oss</a>
                </div>
                {!isNativeAppContext && (
                    <div className={'text-center mb-3'}>
                        Har du hamnat fel?{' '}
                        <a href="/">Gå tillbaka till Tradera</a>
                    </div>
                )}
            </div>
            <div className="text-center mb-4">
                <FormFooterLogo />
            </div>
        </>
    );
};
